<template>
  <div class="column content-box p-2 overflow-auto h-4/5">
    <div class="row-content">
      <input
        v-model="initialDate"
        v-mask="'##/##/####'"
        type="text"
        placeholder="Digite uma data de inicio"
        style="height: 46px"
      />
      <input
        v-model="endDate"
        v-mask="'##/##/####'"
        type="text"
        placeholder="Digite uma data de fim"
        style="margin-left: 10px; height: 46px"
      />
      <multiselect
        v-model="inboxId"
        placeholder="Selecione uma caixa de entrada"
        label="name"
        track-by="id"
        :options="inboxes"
        :show-labels="false"
        style="margin-left: 10px"
        :multiple="false"
        :max-height="160"
      />
      <div class="div-button">
        <woot-button
          :disabled="!disabledButton"
          color-scheme="success"
          style="height: 46px"
          @click="fetchAccountCall"
        >
          Buscar
        </woot-button>
      </div>
    </div>
    <div v-if="accountCallFetching" class="flex w-full justify-center">
      <spinner v-if="accountCallFetching" />
    </div>

    <div
      v-if="!accountCall.length && !accountCallFetching"
      class="small-12 medium-5 conversation-metric"
    >
      <span>{{ $t('CAMPAIGN_REPORTS.TABLE.NO_CONTENT') }}</span>
    </div>

    <metric-card
      v-if="accountCall.length"
      :live="false"
      :header="'Dados das Ligações'"
    >
      <ve-table
        :fixed-header="true"
        :columns="columns"
        :table-data="accountCall"
        :max-height="650"
      />
    </metric-card>
  </div>
</template>

<script>
import { VeTable } from 'vue-easytable';
import 'vue-easytable/libs/theme-default/index.css';
import MetricCard from './components/overview/MetricCard';
import Spinner from 'shared/components/Spinner.vue';

import { mapGetters } from 'vuex';
import {
  format,
  lastDayOfMonth,
  startOfMonth,
  differenceInDays,
} from 'date-fns';

import alertMixin from 'shared/mixins/alertMixin';

export default {
  components: {
    VeTable,
    MetricCard,
    Spinner,
  },
  mixins: [alertMixin],
  data() {
    return {
      inboxId: {},
      initialDate: format(startOfMonth(new Date()), 'dd/MM/yyyy'),
      endDate: format(lastDayOfMonth(new Date()), 'dd/MM/yyyy'),
      loading: false,
      dataFinding: false,
    };
  },
  computed: {
    ...mapGetters({
      accountId: 'getCurrentAccountId',
      accountCall: 'getAccountCall',
      accountCallFetching: 'getAccountCallFetching',
    }),
    inboxes() {
      return this.$store.getters['inboxes/getInboxesTelephony'];
    },
    columns() {
      return [
        {
          field: 'name',
          key: 'name',
          title: 'Agente',
          fixed: 'left',
          align: 'left',
          width: 10,
        },
        {
          field: 'total_duration',
          key: 'leads_trab_1',
          title: 'Segundos',
          align: 'left',
          width: 10,
        },
        {
          field: 'num_registros',
          key: 'leads_received',
          title: 'Total de ligações feitas',
          align: 'left',
          width: 10,
        },
        {
          field: 'phone_number',
          key: 'phone_number',
          title: 'Numero do cliente',
          align: 'left',
          width: 10,
        },
        {
          field: 'price',
          key: 'price',
          title: 'Valor',
          align: 'left',
          width: 10,
        },
      ];
    },
    disabledButton() {
      return Boolean(
        this.initialDate.length === 10 &&
          this.endDate.length === 10 &&
          Object.keys(this.inboxId).length
      );
    },
  },
  methods: {
    fetchAccountCall() {
      const isToLonger = differenceInDays(
        new Date(
          this.endDate.split('/')[2],
          this.endDate.split('/')[1],
          this.endDate.split('/')[0]
        ),
        new Date(
          this.initialDate.split('/')[2],
          this.initialDate.split('/')[1],
          this.initialDate.split('/')[0]
        )
      );
      if (isToLonger > 31) {
        this.showAlert('As datas devem ter no máximo 31 dias de diferença');
        return;
      }

      if (isToLonger < 0) {
        this.showAlert('Informe datas válidas');
        return;
      }

      try {
        this.$store.dispatch('fetchAccountCall', this.getRequestPayload());
      } catch {
        this.showAlert(this.$t('REPORT.SUMMARY_FETCHING_FAILED'));
      }
    },
    getRequestPayload() {
      const init = String(this.initialDate).split('/');
      const end = String(this.endDate).split('/');
      const initialDate = `${init[2]}-${init[1]}-${init[0]}`;
      const endDate = `${end[2]}-${end[1]}-${end[0]}`;

      return {
        from: initialDate,
        to: endDate,
        inbox_id: this.inboxId.id,
      };
    },
  },
};
</script>

<style>
.row-content {
  display: flex;
}

.div-button {
  width: 130px;
  margin-left: 10px;
}
</style>
